<style scoped>
.title span {
  font-size: 20px;
  font-weight: 549;
}
.map-data {
  padding: 0;
  padding-bottom: 15px;
}
h4.title button {
  float: right;
  margin-left: 10px;
}
</style>

<template>
  <div>
    <dimension-dialog
      v-if="showExport"
      :cityName="provinceName"
      :provinCode="provinceCode"
      @hideExport="hideExport1"
      :moduleName="moduleName"
      :autoChunkMonth="true"
    />
    <div style="padding:20px;background:#fff;border-radius:10px;">
      <carStopNonPetrified
        v-if="showDetails"
        :areaList="areaList"
        :pathWayCityName="pathWayCityName"
        :brandName="brandName"
        :provinceName="provinceName"
        :dimObj="getNewDimObj()"
        @closeHtml="hideDetails"
      />
      <div v-else>
        <div class="top-div">
          <h4 class="title">
            <span>货运平台车辆停靠各省地市分品牌加油站车次统计</span>
          </h4>
          <div class="privice-tiem">
            <span style="margin-right: 10px;">统计时间</span>
            <dimension-popover :isMapValue="true" :dimObj="dimObj" :change="changeDimension" :showBottomButton="false" :isItemBindClick="true"  ref="objDimensionPopover"/>
            <el-button v-show="hideExport" @click="exportDate">导出</el-button>
            <el-button @click="goback" v-if="utype!=2">返回上一级</el-button>
            <el-button class="active_btn_r"  v-if="jurisdiction(412)&&utype==2" @click="goComp">停靠非石化油站企业列表 >></el-button>
          </div>
        </div>
        <div class="map-data">
          <map-data-table
            :areaList="areaList"
            v-if="areaList&&areaList.length>0"
            :changeCity="changeCity"
            :num="num"
          ></map-data-table>
        </div>
        <el-table ref="singleTable" :data="tableData" :max-height="tableHeight" stripe style="width: 100%">
          <el-table-column type="index" width="50" label="序号 " align="center"></el-table-column>
          <el-table-column property="pathWayCityName" label="地市" align="center"></el-table-column>
          <el-table-column label="停靠加油站次数" align="center">
            <template slot-scope="scope">
              <span>{{format(scope.$index==0?scope.row.totalNum:scope.row.totalNumber)}}</span>
            </template>
          </el-table-column>
          <!--label=停靠中国石化油站次数-->
          <el-table-column align="center" label="停靠S级油站油站次数">
            <template slot-scope="scope">
              <span v-if="scope.$index==0">{{format(scope.row.petrifactionNum)}}</span>
              <span v-else>{{scope.row.中国石化?format(scope.row.中国石化):"-"}}</span>
            </template>
          </el-table-column>
          <!--label=停靠中国石油油站次数-->
          <el-table-column property="guodao" label="停靠C级油站油站次数" align="center">
            <template slot-scope="scope">
              <span v-if="scope.$index==0">{{format(scope.row.oilCompanyNum)}}</span>
              <span v-else>{{scope.row.中国石油?format(scope.row.中国石油):"-"}}</span>
            </template>
          </el-table-column>
          <!--label=停靠其他油站次数-->
          <el-table-column property="guodao" label="停靠E级油站次数" align="center">
            <template slot-scope="scope">
              <span v-if="scope.$index==0">{{format(scope.row.otherNum)}}</span>
              <span v-else>{{scope.row.其他?format(scope.row.其他):"-"}}</span>
            </template>
          </el-table-column>
          <el-table-column label align="center"  width="150">
            <template slot-scope="scope">
              <el-button type="text" @click="details(scope.$index, scope.row)">油站明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="width: fit-content; margin-left: auto; margin-right: auto;">
          <el-pagination
          @current-change="changeData"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total"
          slot="pagin"
        ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mapDataTable from './components/mapDataTable.1.vue'
import carStopNonPetrified from '../carStopNonPetrified/index.vue'
import Cookies from 'js-cookie'
import https from '@/api/freight.js'
import { hideExport } from '@/utils/tools'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import get from 'lodash/get'
import set from 'lodash/set'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    mapDataTable,
    carStopNonPetrified,
    dimensionDialog,
    dimensionPopover
  },
  data() {
    return {
      hideExport:hideExport,
      areaList: [], //省列表,
      provinceName: '',
      pathWayCityName: '',
      showExport: false,
      moduleName: 'pathwayCityOil',
      // allData: allDatas,
      showDetails: false,
      i: 0,
      num: 0,
      currentPage: 1,
      total: 0,
      pageSize: 50,
      tableData: [],
      utype:0,
      firstPageLoad:"1"
    }
  },
  props: {
    proCode: String,
    dataType: String,
    brandName: String,
    tab: Number,
    dimObj: {
      default: () => {
        return {
          year: "2022",
          month: "02",
          type: "0",
        }
      },
      type: Object
    },
  },
  created() {
    this.initData()
  },
  mounted() {
    console.log(this.dimObj,"dababab")
    this.utype = Cookies.get('userType')
    this.provinceCode = this.proCode
    this.provinceName = this.dataType
    this.num = this.tab
    this.getlist()
    console.log(this,"thsi")
  },
  methods: {
    getNewDimObj(){
      return cloneDeep(this.dimObj)
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    //导出
    exportDate() {
      this.showExport = true
    },
     changeData(index) {
      // 翻页 参数为页码
      this.currentPage = index
      this.getlist()
    },
    getlist() {
      this.tableData = []
      let yearTime = '', monthTime = ''
      if(2 == this.utype&&this.firstPageLoad==1){
        yearTime = ''
        monthTime = ''
      }else{
        yearTime = this.dimObj.year
        monthTime = this.dimObj.month
      }
      let page = this.currentPage
      let pageSize = this.pageSize
      https.getCityBrandList({
          yearTime,
          pathwayProvcode: this.provinceCode,
          monthTime,
          page,
          pageSize,
          timeType: get(this,"dimObj.type","0")
        })
        .then(e => {
        if(this.utype==2&&this.firstPageLoad){
              this.firstPageLoad=0
              set(this,"dimObj.year",e.data.yearTime)
              set(this,"dimObj.month",e.data.monthTime)
              this.$refs.objDimensionPopover.setCtrlValue()
      
        }
          if (e.data) {
            let tableData = e.data.resultList
            let totalMap = e.data.totalMap
            totalMap.pathWayCityName = '合计'
            tableData.unshift(totalMap)
            this.tableData = tableData
            this.total = e.data.totalStripNum
          }
        })
    },
    // 查看明细
    details(index, row) {
      if (row.pathWayCityName) {
        this.pathWayCityName =
          row.pathWayCityName == '合计' ? '' : row.pathWayCityName
      }
      this.showDetails = true
    },
    hideDetails() {
      this.showDetails = false
    },
    changeDimension(e){
      if(e.isOk){
        this.dimObj.year = e.year;
        this.dimObj.month = e.month;
        this.dimObj.type = e.type;
        this.changeTime();
      }
    },
    changeTime() {
      this.currentPage=1
      this.getlist()
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    goback() {
      this.$emit('closeHtml')
    },
    initData() {
      let that = this
      https.getProvinces().then(e => {
        that.areaList = e.data
        let data = e.data
        this.provinceCode = this.proCode==''?data.provinceCode:this.proCode
        this.provinceName = this.dataType==''? data.provinceName:this.dataType
      })
    },
    changeCity(index, item) {
      this.provinceCode = item.provinceCode
      this.provinceName = item.provinceName
      this.currentPage = 1
      this.getlist()
      this.num = index
    },
    goComp(){
      this.$router.push({
        name: 'carUnpetrifiedCom',
      })
    },
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
  }
}
</script>